export const isGradientColor = (color: string) =>
    color.toLowerCase().includes('gradient')
